import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';

import { GridBox, Text } from '@eltoro-ui/components';

import { getAbbreviatedNumber, getIconBuzzColor, getBuzz } from 'Helpers';

import type { APIFeatureType } from 'types';

import './MapPopup.scss';

export const MapPopup: React.FC<{ feature: APIFeatureType }> = ({ feature }) => {
  function days(index: number) {
    switch (index) {
      case 0:
        return 'S';
      case 1:
        return 'M';
      case 2:
        return 'T';
      case 3:
        return 'W';
      case 4:
        return 'T';
      case 5:
        return 'F';
      case 6:
        return 'S';
      default:
        return '';
    }
  }

  const currentDay: number = new Date().getDay();
  const max = (feature?.buzz_history && Math.max(...feature.buzz_history)) ?? 0;
  const color = getIconBuzzColor(feature);
  const buzz = getBuzz(feature);

  return (
    <div className="MapPopup">
      <GridBox gridTemplateColumns="repeat(2, 1fr)" UNSAFE_style={{ padding: '0 0 1rem' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div className="MapPopup__header">
            <b>Weekly Buzz</b>
            <br />
            <Text on="white">{feature.street}</Text>
            <br />
            <Text on="white">Listing ID: {feature.mls_id}</Text>
          </div>
          <GridBox gridTemplateColumns="max-content" gap=".5rem" UNSAFE_className="MapPopup__body">
            <Text on="white">
              <span>
                <FontAwesomeIcon icon={faStar} style={{ color: 'gold' }} />
              </span>{' '}
              Beds - {feature.beds === 0 ? 'N/A' : feature.beds}
            </Text>
            <Text on="white">
              <span>
                <FontAwesomeIcon icon={faStar} style={{ color: 'gold' }} />
              </span>{' '}
              Baths - {feature.baths === 0 ? 'N/A' : feature.baths}
            </Text>
            <Text on="white">
              <span>
                <FontAwesomeIcon icon={faStar} style={{ color: 'gold' }} />
              </span>{' '}
              Listed Price -{' '}
              {feature.listing_price === 0
                ? 'N/A'
                : `$${getAbbreviatedNumber(feature.listing_price.toString())}`}
            </Text>
          </GridBox>
        </div>
        <div
          style={{
            marginLeft: '15px',
            display: 'flex',
            height: '100%',
          }}
        >
          {feature?.buzz_history?.map((item: number, index: number) => {
            return (
              <div className="feature-buzz_history" key={index}>
                <div
                  className="feature-buzz_history-line"
                  style={{
                    backgroundColor: currentDay === index ? '#F66233' : 'grey',
                    height: `${(item / max) * 7}rem`,
                  }}
                />
                <p
                  className="feature-buzz_history-text"
                  style={{
                    color: currentDay === index ? '#F66233' : '',
                    fontWeight: currentDay === index ? 'bold' : '400',
                  }}
                >
                  {days(index)}
                </p>
              </div>
            );
          })}
        </div>
      </GridBox>
      {feature.buzz_score && (
        <div className="MapPopup__buzzStatus" style={{ backgroundColor: color }}>
          {buzz.toUpperCase()}
        </div>
      )}
    </div>
  );
};
